export const getWindowSize = () => ({
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
});

export const getCurrentPathname = () => window.location.pathname;
